<script lang="ts">
  import { cn } from '$lib/utils';

  export let href: string | undefined;
  let className: undefined | string = undefined;
  export { className as class };
</script>

<a
  {href}
  class={cn(
    'flex flex-col items-center justify-center rounded-sm border-none bg-primary/4 p-5 text-sm font-semibold text-primary/80 shadow-none outline-none transition-shadow focus-visible:ring',
    className
  )}
  {...$$restProps}
>
  <slot />
</a>
